<template>
  <div class="group relative" :class="{ 'animate-pulse': true }">
    <article>
      <div
        class="max-h-md group relative flex items-center justify-center bg-gray"
        :style="{ aspectRatio: '7/12' }"
      ></div>
      <div class="pb-0.5 pt-[9px] lg:pt-[15px]">
        <div class="mt-2"></div>
      </div>
    </article>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ProductCardSkeleton',
})
</script>
